export const OCR_MESSAGE_ACCESS_SHORT = (t: $TSMigrationFixMe) => {
  return {
    title: `${t("ocr.title")}`,
    subtitle: `${t("ocr.subtitle")}`,
    icon: "vector-square",
    section: `${t("ocr.section")}`,
    link: "/ocr",
  }
}
